import { render } from "./GiftSendMultiItem.vue?vue&type=template&id=388cecee&scoped=true"
import script from "./GiftSendMultiItem.vue?vue&type=script&lang=js"
export * from "./GiftSendMultiItem.vue?vue&type=script&lang=js"

import "./GiftSendMultiItem.vue?vue&type=style&index=0&id=388cecee&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388cecee"]])

export default __exports__